// `window.gtag` is typed by @gjl/analytics's ambient `Gtag` global (in the
// compile via @gjl/site-kit). A local declaration here would conflict with it.

function track(eventName: string, params: Record<string, unknown>) {
  window.gtag?.('event', eventName, params)
}

/** Track when a visitor views a blog post */
export function trackBlogView(slug: string, category: string) {
  track('blog_view', {
    event_category: 'content',
    blog_slug: slug,
    blog_category: category,
    source: 'blog',
  })
}
